export type MessageType = 'system' | 'business' | 'alert'

export type MessageReadFilter = 'all' | 'unread' | 'read'

export type MessageTypeFilter = MessageType | 'all'

export type ConversationKind = 'direct' | 'group' | 'bot' | 'notice'

export type ConversationMenuCommand =
  | 'unread'
  | 'mute'
  | 'pin'
  | 'star'
  | 'label'
  | 'hide'
  | 'clear'
  | 'delete'

export type GroupMemberMenuCommand =
  | 'direct'
  | 'profile'
  | 'mention'
  | 'copy-account'
  | 'copy-email'

export type ChatMessageFrom = 'self' | 'peer' | 'system'

export type ChatMessageKind = 'text' | 'image' | 'file' | 'card'

export interface ConversationMember {
  id: string
  name: string
  kind?: 'user' | 'bot' | 'company' | 'dept'
  username?: string
  email?: string
}

export interface ChatMessage {
  id: string
  conversationId: string
  from: ChatMessageFrom
  kind: ChatMessageKind
  content: string
  createTime: string
  senderName?: string
  fileName?: string
  read?: boolean
  payload?: Record<string, unknown>
}

export interface Conversation {
  id: string
  kind: ConversationKind
  title: string
  subtitle?: string
  online?: boolean
  starred?: boolean
  muted?: boolean
  pinned?: boolean
  pinnedAt?: string
  labels?: string[]
  lastPreview: string
  lastTime: string
  unread: number
  members?: ConversationMember[]
  type?: MessageType
  sender?: string
  bizTab?: string
  payload?: Record<string, unknown>
}

export interface MessageRecord {
  id: string
  title: string
  content: string
  type: MessageType
  read: boolean
  sender: string
  createTime: string
  /** 关联 App Tab name */
  bizTab?: string
  payload?: Record<string, unknown>
}

export interface MessageSummaryStats {
  unread: number
  system: number
  business: number
  alert: number
}

export const TYPE_TAG_MAP: Record<
  MessageType,
  { type: 'info' | 'primary' | 'success' | 'danger' | 'warning'; label: string }
> = {
  system: { type: 'info', label: '系统' },
  business: { type: 'primary', label: '业务' },
  alert: { type: 'danger', label: '告警' },
}

export const TYPE_AVATAR_COLOR: Record<MessageType, string> = {
  system: 'var(--z-color-info)',
  business: 'var(--z-color-primary)',
  alert: 'var(--z-color-danger)',
}

export const BIZ_TAB_LABELS: Record<string, string> = {
  piece: '计件',
  process: '工序',
  user: '用户表',
  lov: 'LOV 字典',
  menu: '树表',
  'rule-aviator': 'Aviator 规则',
  'data-source': '数据源',
}
